import { render, staticRenderFns } from "./SupportFab.vue?vue&type=template&id=06325f68&scoped=true&"
import script from "./SupportFab.vue?vue&type=script&lang=js&"
export * from "./SupportFab.vue?vue&type=script&lang=js&"
import style0 from "./SupportFab.vue?vue&type=style&index=0&id=06325f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06325f68",
  null
  
)

export default component.exports